import { client, getUrl } from "utils";

export const getProxiesRequest = (filterParams) => client.get(getUrl("proxies", filterParams));

export const handleDeleteProxyRequest = (id) => client.delete(`proxy/${id}`);

export const handleAttachTagRequest = (data) => client.post(`tag/${data.id}/add`, data.body);

export const handleDetachTagRequest = (data) => client.delete(`tag/${data.id}/delete/${data.tag}`);

export const handleCreateProxyRequest = (data) => client.post("proxies", data);

export const getCountProxiesRequest = (filterParams) => client.get(getUrl("proxies", filterParams));
